import React, { useState, useEffect, useRef } from "react";
import { useSelector } from 'react-redux';
import apiServices from '../../../actions/services'

const BloquearAccesoModal = ({ empleados: empleadosProp = [] }) => {
  const { user } = useSelector(state => state.auth);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [motivo, setMotivo] = useState("");
  const [empleados, setEmpleados] = useState([]);
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null);
  const [busquedaEmpleado, setBusquedaEmpleado] = useState("");
  const [empleadosFiltrados, setEmpleadosFiltrados] = useState([]);
  const [mostrarListaEmpleados, setMostrarListaEmpleados] = useState(false);
  
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  // console.log(empleadosProp)
  // console.log(empleados);
  // Inicializar con los empleados recibidos por props
  useEffect(() => {
    setEmpleados(empleadosProp);
    setEmpleadosFiltrados(empleadosProp);
  }, [empleadosProp]);

  // Filtrar empleados mientras se escribe
  useEffect(() => {
    const timer = setTimeout(() => {
      const filtrados = empleados.filter(emp => {
        const codigo = String(emp.exp_codigo_alternativo || '').toLowerCase();
        const nombre = String(emp.exp_nombre_usual || '').toLowerCase();
        const busqueda = busquedaEmpleado.toLowerCase();
        return codigo.includes(busqueda) || nombre.includes(busqueda);
      });
      setEmpleadosFiltrados(filtrados);
    }, 200);

    return () => clearTimeout(timer);
  }, [busquedaEmpleado, empleados]);

  // Manejar clics fuera del dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && 
          inputRef.current && !inputRef.current.contains(event.target)) {
        setMostrarListaEmpleados(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInputClick = () => {
    if (empleados.length > 0) {
      setMostrarListaEmpleados(true);
    }
  };
  const formatDate = () => {
    const now = Date.now();
    const date = new Date(now);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  };
  const seleccionarEmpleado = (empleado) => {
    setEmpleadoSeleccionado(empleado);
    setBusquedaEmpleado(`${empleado.exp_codigo_alternativo} - ${empleado.exp_nombre_usual}`);
    setMostrarListaEmpleados(false);
  };

  const handleGuardar = () => {
    if (!empleadoSeleccionado || !motivo) return;
    // console.log("Empleado seleccionado:", empleadoSeleccionado);
    // console.log("Motivo:", motivo);
    // console.log("user",user);
    const structure= [{"CodEmp":empleadoSeleccionado.exp_codigo_alternativo,"Fecha":formatDate(),"Comentario":motivo,"CodEmpAut":user.id_usuario}]
    //console.log(structure);
    const response = apiServices.post('GenerarBloqueoMarcaje',structure);
    //console.log(response);
    setIsModalOpen(false);
  };

  return (
    <div>
      <button
        onClick={() => setIsModalOpen(true)}
        style={{
          padding: "10px 20px",
          background: "#dc3545",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: "14px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          transition: "all 0.3s ease",
          ":hover": {
            background: "#c82333",
            transform: "translateY(-1px)",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
          }
        }}
      >
        Bloquear Acceso
      </button>

      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={() => setIsModalOpen(false)}
        >
          <div
            style={{
              background: "white",
              padding: "25px",
              borderRadius: "10px",
              width: "500px",
              maxWidth: "90%",
              boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 style={{ marginTop: 0, color: "#333" }}>Bloquear Acceso</h2>

            <div style={{ marginBottom: "20px", position: "relative" }}>
              <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>
                Seleccionar Empleado:
              </label>
              <input
                ref={inputRef}
                type="text"
                value={busquedaEmpleado}
                onChange={(e) => {
                  setBusquedaEmpleado(e.target.value);
                  setMostrarListaEmpleados(true);
                }}
                onClick={handleInputClick}
                onFocus={handleInputClick}
                placeholder="Buscar por código o nombre..."
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  fontSize: "14px",
                  ":focus": {
                    borderColor: "#80bdff",
                    outline: "none",
                    boxShadow: "0 0 0 0.2rem rgba(0,123,255,0.25)"
                  }
                }}
              />
              
              {mostrarListaEmpleados && (
                <div
                  ref={dropdownRef}
                  style={{
                    position: "absolute",
                    top: "calc(100% + 5px)",
                    left: 0,
                    right: 0,
                    maxHeight: "250px",
                    overflowY: "auto",
                    background: "white",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    zIndex: 1001,
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  {empleadosFiltrados.length === 0 ? (
                    <div style={{ padding: "12px", color: "#666", textAlign: "center" }}>
                      {busquedaEmpleado ? "No hay coincidencias" : "No hay empleados disponibles"}
                    </div>
                  ) : (
                    empleadosFiltrados.map(empleado => (
                      <div
                        key={empleado.exp_codigo_alternativo}
                        onClick={() => seleccionarEmpleado(empleado)}
                        style={{
                          padding: "12px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                          backgroundColor: empleadoSeleccionado?.exp_codigo_alternativo === empleado.exp_codigo_alternativo 
                            ? "#f0f7ff" 
                            : "white",
                          ":hover": {
                            backgroundColor: "#f5f5f5"
                          }
                        }}
                      >
                        <div style={{ fontWeight: "500" }}>{empleado.exp_nombre_usual}</div>
                        <div style={{ fontSize: "12px", color: "#666" }}>Código: {empleado.exp_codigo_alternativo}</div>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>

            <div style={{ marginBottom: "25px" }}>
              <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>
                Motivo del bloqueo:
              </label>
              <textarea
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  minHeight: "120px",
                  resize: "vertical",
                  fontSize: "14px",
                  ":focus": {
                    borderColor: "#80bdff",
                    outline: "none",
                    boxShadow: "0 0 0 0.2rem rgba(0,123,255,0.25)"
                  }
                }}
                placeholder="Describa detalladamente el motivo del bloqueo..."
              />
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
              <button
                onClick={() => setIsModalOpen(false)}
                style={{
                  padding: "10px 20px",
                  background: "#6c757d",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "500",
                  transition: "all 0.2s ease",
                  ":hover": {
                    background: "#5a6268"
                  }
                }}
              >
                Cancelar
              </button>
              <button
                onClick={handleGuardar}
                disabled={!empleadoSeleccionado || !motivo}
                style={{
                  padding: "10px 20px",
                  background: !empleadoSeleccionado || !motivo ? "#cccccc" : "#28a745",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  cursor: !empleadoSeleccionado || !motivo ? "not-allowed" : "pointer",
                  fontWeight: "500",
                  transition: "all 0.2s ease",
                  ":hover": (!empleadoSeleccionado || !motivo) ? {} : {
                    background: "#218838"
                  }
                }}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BloquearAccesoModal;